import React, { Component } from "react";
import { func, oneOf } from "prop-types";
import Col from "../../common/grid/Col";
import Row from "../../common/grid/Row";
import Button from "../../common/button/Button";
import MdClose from "react-icons/lib/md/close";

import "./Modal.css";

class Modal extends Component {
	static PropTypes = {
		onConfirm: func,
		onCancel: func,
		type: oneOf(["CONFIRMATION", "GENERAL"])
	};

	static defaultProps = {
		type: "GENERAL"
	};

	constructor(props) {
		super(props);
		this.toggleBodyFocus = this.toggleBodyFocus.bind(this);
		this.toggleBodyFocus(true);
		this._onKeydown = this._onKeydown.bind(this);
	}

	toggleBodyFocus(show) {
		document.body.classList.toggle("focused-out", show);
	}

	componentDidMount() {
		document.addEventListener("keydown", this._onKeydown);
	}

	_onKeydown(event) {
		if (event.which === 27) this.props.onCancel();
	}

	componentWillUnmount() {
		this.toggleBodyFocus(false);
		document.removeEventListener("keydown", this._onKeydown);
	}

	render() {
		const { onConfirm, onCancel, type } = this.props;
		if (type === "CONFIRMATION") {
			return (
				<Col _bottom-32 modal>
					<h1>{this.props.children}</h1>
					<Row _flex-end _gap-16 _no-grow modal-buttons>
						<Button className="btn-plain" onClick={onConfirm}>
							CONFIRM
						</Button>
						<Button className="btn-plain" onClick={onCancel}>
							CANCEL
						</Button>
					</Row>
				</Col>
			);
		} else if (type === "GENERAL") {
			return (
				<div className="modal">
					{this.props.children}
					<button className="btn-plain close">
						<MdClose size={24} onClick={onCancel} />
					</button>
				</div>
			);
		}
	}
}

export default Modal;



// WEBPACK FOOTER //
// ./src/common/modal/Modal.js